module.exports = __webpack_public_path__ + "static/media/dumbbell-white.6d83e446.svg";